import styles from "./Loading.module.scss";

type Props = {
	isLoading: boolean;
};

function Loading({ isLoading }: Props) {
	return (
		<>
			{isLoading ? (
				<div className={styles.LoadingWrapper}>
					<div className={styles.Loading}>loading...</div>
				</div>
			) : null}
		</>
	);
}

export default Loading;
